import { render, staticRenderFns } from "./ReservationForm.vue?vue&type=template&id=56d2c4ea&scoped=true"
import script from "./ReservationForm.vue?vue&type=script&lang=ts"
export * from "./ReservationForm.vue?vue&type=script&lang=ts"
import style0 from "./ReservationForm.vue?vue&type=style&index=0&id=56d2c4ea&prod&lang=less&scoped=true"
import style1 from "./ReservationForm.vue?vue&type=style&index=1&id=56d2c4ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_coffee-script@1.12.7_css-loader@5.2.7_webpack@5.75_86376c8867defa2ab34ac3cb7ab0bafc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2c4ea",
  null
  
)

export default component.exports